import React from "react";

import UserIcon from "core/gd-ui/icon/user/user";

import Classes from "classnames";

export default function ModalAddUserProjectUsersRow(props) {

    const onClick = (e) => {
        props.onClick(props.user.id, e)
    }

    let col0 = false;
    if (props.multiselect) {

        const checkboxClasses = Classes('ui5-cb', 's-16', {
            selected: props.isSelected
        });

        col0 = (
            <div className="cell center">
                <div className={checkboxClasses}/>
            </div>
        )
    }

    const classes = Classes('row',{
        selected: props.isSelected
    });

    return (
        <div className={classes} onClick={onClick}>
            {col0}
            <div className="cell content">
                <UserIcon userId={props.user.id} size="26" className="m-r-10" />
                <div className="user-name">{props.user.name}</div>
            </div>
            <div className="cell"/>
        </div>
    )
}